module.exports = __webpack_public_path__ + "components/rewards/bird-eyewear/static/logo-98bbcf4ffecbecf5772ac32e5ccdcdc2.webp";